import { LoginResult } from '../../interface/user/login';
import { intercepter, mock } from '../config';

mock.mock(/\/auth\/login\/mock*/, 'post', (config: any) => {
    const body: LoginResult = JSON.parse(config?.body);
    const generateToken = () => {
        return Math.random().toString(36).substr(2);
    };

    return intercepter<LoginResult>(
        {
            token: generateToken(),
            email: body?.email,
            roles: ['admin'],
            id: 1,
        },
        null
    );
});
